import moment from "../../../node_modules/moment/moment";
import { InscriptionFile } from "./InscriptionFile";
import { FilePropertiesValidation } from "../../FilePropertiesValidation";
import cloneDeep from "lodash/cloneDeep";
import { MultiLanguage } from "../../MultiLanguage";
import { Requirement } from "../inscriptionStructure/Requirement";
import { OnlinePaymentInfo } from "../inscriptionStructure/OnlinePaymentInfo";
import { MeritGroupStep } from "../step/MeritGroupStep";
import { Representative } from "../../Representative";
import { PersonalDataDetails } from "../inscriptionStructure/PersonalDataDetails";
import { Address } from "../inscriptionStructure/Address";
import { ContactData } from "../inscriptionStructure/ContactData";
import { Authorization } from "../inscriptionStructure/Authorization";
import { DisabilityData } from "../inscriptionStructure/DisabilityData";
import { LegalConsent } from "../inscriptionStructure/LegalConsent";
import { InscriptionDocument } from "../myInscription/InscriptionDocument";
import { PayExemption } from "../payExemption/PayExemption";
import { PaymentMethod } from "../../enum/PaymentMethod";
import { PaymentType } from "../../enum/PaymentType";
import { PayExemptionTypes } from "../../enum/PayExemptionTypes";
import _ from "lodash";
import { IInscriptionReference } from "../../interfaces/IReference";

export class Inscription {
    private _id: string;
    private _processId: string;
    // Personal Data
    private _personalDataDetails: PersonalDataDetails;
    // Adress
    private _address: Address;
    // Contact Data;
    private _contactData: ContactData;
    // Authorization
    private _authorization: Authorization;
    // Disability Data
    private _disabilityData: DisabilityData;
    // Legal Consent
    private _legalConsent: LegalConsent;
    // Requirements
    private _requirements: Requirement[];
    // Merits
    private _meritGroups: any[];
    // Documents
    private _documents: InscriptionFile[];
    // PayExemption
    private _payExemption: PayExemption;
    // PaymentMethod
    private _paymentMethod: number;
    // Creditable Exams
    private _creditableExams: any[];
    // Has sumary MeritGroups
    private _hasAutoScaling: boolean;
    // File Properties Validation
    private _paymentBox: any;
    private _feePaymentBox: any;
    // Process
    private _processTitle: MultiLanguage;
    private _processEndDate: moment.Moment | null;
    private _processEntityName: string;
    private _processHasFeePayment: boolean;
    private _processHasOnlinePayment: boolean;
    private _processHasPasarelaPayment: boolean;
    private _processPaymentType: number | null;
    private _hasAuthorizationProcess: boolean;
    private _hasCryptoSignature: boolean;
    // Representative
    private _hasRepresentative: boolean;
    private _representative: Representative;
    // CriptoSignature
    private _cryptoSignature: any = null;
    // OnlinePaymentInfo
    private _onlinePaymentInfo: OnlinePaymentInfo;
    // JustificationDocuments
    private _justificationDocuments: InscriptionDocument[] | null;
    // References
    private _references: IInscriptionReference[] = [];

    constructor(data: any, hasAutoScaling: boolean, processesConfigurationPayExemptions?: any) {
        this._id = data.id;
        this._processId = data.processId;
        this._personalDataDetails = new PersonalDataDetails(data.personalData.personalDataDetails);
        this._address = new Address(data.personalData.address);
        this._contactData = new ContactData(data.personalData.contactData);
        this._authorization = new Authorization(data.personalData.authorization);
        this._hasAuthorizationProcess = null;
        this._disabilityData = new DisabilityData(data.personalData.disabilityData);
        this._legalConsent = new LegalConsent(data.legalConsent);
        this._requirements = data.requirements || [];
        this._meritGroups = data.meritGroups.map(meritGroup => new MeritGroupStep(meritGroup)) || [];
        this._documents = data.documents.map((file: any) => new InscriptionFile(file)) || [];
        this._payExemption = new PayExemption(data.payExemption, processesConfigurationPayExemptions);
        this._paymentMethod = data.paymentMethod;
        this._creditableExams = data.creditableExams || [];
        this._hasAutoScaling = hasAutoScaling;
        this._paymentBox = new FilePropertiesValidation();
        this._feePaymentBox = new FilePropertiesValidation();
        this._processTitle = new MultiLanguage(data.processTitle);
        this._processEntityName = '';
        this._processEndDate = null;
        this._processHasFeePayment = false;
        this._processHasOnlinePayment = false;
        this._processHasPasarelaPayment = false;
        this._processPaymentType = null;
        this._hasRepresentative = data.hasRepresentative;
        this._representative = data.hasRepresentative ? new Representative(data.representative) : null;
        this._hasCryptoSignature = false;
        this._onlinePaymentInfo = data.inscriptionOnlinePaymentInfoDto ? new OnlinePaymentInfo(data.inscriptionOnlinePaymentInfoDto) : null;
        this._justificationDocuments = data.justificationDocuments && data.justificationDocuments.length > 0 ? data.justificationDocuments.map(justificationDocument => new InscriptionDocument(justificationDocument)) : null;
        this._references = data.references ? data.references : [];
    }

    public toServer() {
        let meritGroupsToServe = cloneDeep(this.meritGroups);
        if (this._hasAutoScaling) {
            meritGroupsToServe.splice(-1, 1);
        }
        meritGroupsToServe = meritGroupsToServe.map(element => element.toServer());
        return {
            inscriptionId: this._id,
            processId: this._processId,
            personalDataDetails: this._personalDataDetails.toServer(),
            address: this._address.toServerInscription(),
            contactData: this._contactData.toServerInscription(),
            authorization: this._hasAuthorizationProcess ? this._authorization.toServer() : {},
            disabilityData: this._disabilityData.toServer(),
            legalConsent: this._legalConsent.toServer(),
            requirements: this._requirements,
            payExemption: this._payExemption.toServer(),
            paymentMethod: this._paymentMethod,
            meritGroups: meritGroupsToServe,
            creditableExams: this._creditableExams,
            hasRepresentative: this._hasRepresentative,
            representative: this._hasRepresentative ? this._representative.toServer() : null,
            cryptoSignature: this._cryptoSignature,
            references: this.references.length ? this.references : []
        }
    }

    public meritsToServer() { //modificar y mandar solo los rellenos
        let meritGroupsToServe = cloneDeep(this.meritGroups);
        if (this._hasAutoScaling) {
            meritGroupsToServe.splice(-1, 1);
        }
        meritGroupsToServe = meritGroupsToServe.map(element => element.toServer())

        meritGroupsToServe.forEach(group => {
            group.merits = group.merits.filter(merit => merit.userTotalScore > 0)
        })

        meritGroupsToServe = meritGroupsToServe.filter(group => group.merits.length);

        return {
            inscriptionId: this._id,
            groups: meritGroupsToServe,
            cryptoSignature: this._cryptoSignature
        }
    }

    public get id() {
        return this._id;
    }
    public set id(id: string) {
        this._id = id;
    }

    public get processId() {
        return this._processId;
    }
    public set processId(processId: string) {
        this._processId = processId;
    }

    public get personalDataDetails() {
        return this._personalDataDetails;
    }
    public set personalDataDetails(personalDataDetails: PersonalDataDetails) {
        this._personalDataDetails = personalDataDetails;
    }

    public get address() {
        return this._address;
    }
    public set address(address: Address) {
        this._address = address;
    }

    public get contactData() {
        return this._contactData;
    }
    public set contactData(contactData: ContactData) {
        this._contactData = contactData;
    }

    public get authorization() {
        return this._authorization;
    }
    public set authorization(authorization: Authorization) {
        this._authorization = authorization;
    }

    public get disabilityData() {
        return this._disabilityData;
    }
    public set disabilityData(disabilityData: DisabilityData) {
        this._disabilityData = disabilityData;
    }

    public get legalConsent() {
        return this._legalConsent;
    }
    public set legalConsent(legalConsent: LegalConsent) {
        this._legalConsent = legalConsent;
    }

    public get payExemption() {
        return this._payExemption;
    }
    public set payExemption(payExemption: PayExemption) {
        this._payExemption = payExemption;
    }

    public get hasAuthorizationProcess() {
        return this._hasAuthorizationProcess;
    }
    public set hasAuthorizationProcess(hasAuthorizationProcess: boolean | null) {
        this._hasAuthorizationProcess = hasAuthorizationProcess;
    }

    public get hasCryptoSignature() {
        return this._hasCryptoSignature;
    }
    public set hasCryptoSignature(hasCryptoSignature: boolean) {
        this._hasCryptoSignature = hasCryptoSignature;
    }

    public get cryptoSignature() {
        return this._cryptoSignature;
    }
    public set cryptoSignature(cryptoSignature: any) {
        this._cryptoSignature = cryptoSignature;
    }

    public set paymentBox(paymentBox: any) {
        this._paymentBox = paymentBox;
    }
    public get paymentBox() {
        return this._paymentBox;
    }
    public set feePaymentBox(feePaymentBox: any) {
        this._feePaymentBox = feePaymentBox;
    }
    public get feePaymentBox() {
        return this._feePaymentBox;
    }

    public get requirements() {
        return this._requirements;
    }
    public set requirements(requirements: any[]) {
        this._requirements = requirements;
    }
    public addRequirements(requirements: any[]) {
        this._requirements = requirements.map(ele => new Requirement(ele));
    }

    public get meritGroups() {
        return this._meritGroups;
    }
    public set meritGroups(meritGroups: any[]) {
        this._meritGroups = meritGroups;
    }

    public get documents() {
        return this._documents;
    }
    public set documents(documents: InscriptionFile[]) {
        this._documents = documents;
    }

    public get paymentMethod() {
        return this._paymentMethod;
    }
    public set paymentMethod(paymentMethod: number) {
        this._paymentMethod = paymentMethod;
    }

    public get creditableExams() {
        return this._creditableExams;
    }
    public set creditableExams(creditableExams: any[]) {
        this._creditableExams = creditableExams;
    }

    public get hasAutoScaling() {
        return this._hasAutoScaling;
    }
    public set hasAutoScaling(hasAutoScaling: boolean) {
        this._hasAutoScaling = hasAutoScaling;
    }

    public get processTitle() {
        return this._processTitle;
    }
    public set processTitle(processTitle: MultiLanguage) {
        this._processTitle = processTitle;
    }

    public get processEntityName() {
        return this._processEntityName;
    }
    public set processEntityName(processEntityName: string) {
        this._processEntityName = processEntityName;
    }

    public get processEndDate() {
        return this._processEndDate;
    }
    public set processEndDate(processEndDate: moment.Moment) {
        this._processEndDate = moment(processEndDate);
    }

    public get processHasFeePayment() {
        return this._processHasFeePayment;
    }
    public set processHasFeePayment(processHasFeePayment: boolean) {
        this._processHasFeePayment = processHasFeePayment;
    }

    public get processHasOnlinePayment() {
        return this._processHasOnlinePayment;
    }
    public set processHasOnlinePayment(processHasOnlinePayment: boolean) {
        this._processHasOnlinePayment = processHasOnlinePayment;
    }

    public get processHasPasarelaPayment() {
        return this._processHasPasarelaPayment;
    }
    public set processHasPasarelaPayment(processHasPasarelaPayment: boolean) {
        this._processHasPasarelaPayment = processHasPasarelaPayment;
    }

    public get canBePaymentMethodOnline() {
        return this._processHasPasarelaPayment || this._processHasOnlinePayment;
    }

    public get processPaymentType() {
        return this._processPaymentType;
    }
    public set processPaymentType(processPaymentType: number) {
        this._processPaymentType = processPaymentType;
    }

    public get hasRepresentative() {
        return this._hasRepresentative;
    }
    public set hasRepresentative(hasRepresentative: boolean) {
        this._hasRepresentative = hasRepresentative;
    }

    public get representative() {
        return this._representative;
    }
    public set representative(representative: Representative | null) {
        this._representative = representative;
    }

    public get onlinePaymentInfo() {
        return this._onlinePaymentInfo;
    }
    public set onlinePaymentInfo(onlinePaymentInfo: OnlinePaymentInfo | null) {
        this._onlinePaymentInfo = onlinePaymentInfo;
    }

    public get justificationDocuments() {
        return this._justificationDocuments;
    }

    public get references() {
        return this._references;
    }
    public set references(references: IInscriptionReference[]) {
        this._references = references;
    }

    public setPaymentMethod(pricePayExemption: number) {
        if (!this.processHasFeePayment || (this.processHasFeePayment && this.canBePaymentMethodOnline && pricePayExemption === 0)) {
            this.paymentMethod = PaymentMethod.enum.NONE;
        } else if (!this.canBePaymentMethodOnline) {
            this.paymentMethod = PaymentMethod.enum.OFFLINE;
        } else if (this.processPaymentType === PaymentType.enum.CREDIT_CARD && pricePayExemption > 0) {
            this.paymentMethod = PaymentMethod.enum.ONLINE;
        }
    }

    public someJustificationDocumentHasRegistryReference() {
        return this.justificationDocuments !== null && this.justificationDocuments.some(JustificationDocument => JustificationDocument.registryReference);
    }

    public getOrderedJustificationDocuments() {
        return _.orderBy(this.justificationDocuments, 'order');
    }

    public isPayExemptionTypeNoneOrNoReason() {
        return this.payExemption.payExemptionType === PayExemptionTypes.enum.NONE || this.payExemption.payExemptionType === PayExemptionTypes.enum.NOREASON;
    }
}
